<div class="document">

  @for (area of document.template.areas; track area) {
    <div class="area">
      <app-template-area [templateArea]="area" [document]="document" [form]="form" [metaData]="metaData"></app-template-area>
    </div>
  }

</div>
